<template>
  <div>
    <v-icon left dense v-text="iconTextCode" :color="iconColor" />

    {{
      getActionTranslation(
        LOG_CODE[log.context].action ||
          log.object.status_code ||
          log.object.action ||
          "NOT_FOUND"
      )
    }}

    <v-tooltip
      top
      v-if="log.context === 'update_user' || log.context === 'sync_user_data'"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="grey"
          dark
          v-bind="attrs"
          v-on="on"
          v-text="'ph-question'"
          small
        />
      </template>
      <span class="font-weight-medium">
        {{
          log.context === "sync_user_data"
            ? `${log.author?.name} solicitou a sincronização manual dos dados.`
            : "O sistema detectou alterações no workspace e atualizou o usuário automaticamente."
        }}
      </span>
    </v-tooltip>
  </div>
</template>
<script>
import { getActionTranslation } from "@/helpers/services/logs";
import {
  LOG_CODE,
  LOG_ICON_BY_ACTION,
  LOG_ICON_BY_STATUS_CODE,
  LOG_ICON_COLOR_BY_ACTION,
  LOG_ICON_COLOR_BY_STATUS_CODE,
} from "@/helpers/variables/logs";
export default {
  name: "Action",
  props: {
    log: { type: Object, default: () => {}, required: true },
  },
  data: () => ({
    LOG_CODE,
    LOG_ICON_COLOR_BY_ACTION,
    LOG_ICON_BY_ACTION,
    LOG_ICON_COLOR_BY_STATUS_CODE,
    LOG_ICON_BY_STATUS_CODE,
  }),
  methods: { getActionTranslation },
  computed: {
    iconTextCode() {
      return (
        LOG_CODE[this.log.context].icon ||
        LOG_ICON_BY_STATUS_CODE[this.log.object.status_code] ||
        LOG_ICON_BY_ACTION[this.log.object.action] ||
        LOG_ICON_BY_STATUS_CODE["UNKNOWN_ERROR"]
      );
    },
    iconColor() {
      return (
        LOG_CODE[this.log.context].color ||
        LOG_ICON_COLOR_BY_STATUS_CODE[this.log.object.status_code] ||
        LOG_ICON_COLOR_BY_ACTION[this.log.object.action] ||
        LOG_ICON_BY_STATUS_CODE["UNKNOWN_ERROR"]
      );
    },
  },
};
</script>
